// extracted by mini-css-extract-plugin
module.exports = {"sectionOrganization":"SectionOrganization_sectionOrganization_20rdy"};